/**
 * Shared Slider base for the HSlider/VSlider slices. `Slider` is Godot's abstract base (Range →
 * Slider → H/VSlider), so its properties and their parse live here, in pure `.ts` for the linter
 * graph. The native geometry is `shared/sliderSolver.ts`.
 */
import { parseOptionalBool, parseOptionalInt } from '../../../../parser/valueParsers';
import { parseControl } from '../control/parser';
import { parseRange } from './range';
import { MAX_WALKED_ELEMENTS } from './countWalk';
/** Godot `Slider` property defaults (doc/classes/Slider.xml). */
const SLIDER_DEFAULT_TICK_COUNT = 0;
export const SLIDER_DEFAULT_EDITABLE = true;
/** Control + Range bases plus Slider's own tick/editable properties. */
export function parseSlider(heading, properties) {
    return {
        ...parseControl(heading, properties),
        // HSlider and VSlider both set `step = 1.0` in their constructors
        // (`ClassDB.class_get_property_default_value`, 4.6.3), so a slider without the key still snaps.
        ...parseRange(properties, { step: 1 }),
        tickCount: parseOptionalInt(properties.tick_count),
        ticksOnBorders: parseOptionalBool(properties.ticks_on_borders),
        editable: parseOptionalBool(properties.editable),
    };
}
/**
 * The tick indices `Slider::_notification(NOTIFICATION_DRAW)` paints: none unless `ticks > 1`, and
 * the borders only with `ticks_on_borders` (`if (!ticks_on_borders && (i == 0 || i + 1 == ticks))`).
 */
export function sliderTickIndices(props) {
    // `tick_count` is an unbounded INT slot, so the walk is capped (countWalk.ts): past a thousand,
    // ticks land sub-pixel on each other and no image changes.
    const ticks = Math.min(props.tickCount ?? SLIDER_DEFAULT_TICK_COUNT, MAX_WALKED_ELEMENTS);
    if (ticks <= 1)
        return [];
    const onBorders = props.ticksOnBorders ?? false;
    const indices = [];
    for (let i = 0; i < ticks; i++) {
        if (!onBorders && (i === 0 || i + 1 === ticks))
            continue;
        indices.push(i);
    }
    return indices;
}
//# sourceMappingURL=slider.js.map